import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import { deleteNotesSuccess } from "../slices/features/postNote";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* deleteNoteSaga(action: any) {
  const { payload } = action;
  const { id } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.deleteNotes,
      baseUrl,
      id
    );

    yield put(deleteNotesSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;
    yield put(deleteNotesSuccess({ statusCode, statusText }));
  }
}

export function* watchDeleteNotes() {
  yield takeLatest(RequestTypes.DELETE_NOTE_REQUEST, deleteNoteSaga);
}
